import { connectorSessionGuard, socialUserInfoGuard, } from '@rivenai/connector-kit';
import { z } from 'zod';
import { encryptedTokenSetGuard } from '../secrets.js';
import { VerificationType } from './verification-type.js';
export const socialVerificationRecordDataGuard = z.object({
    id: z.string(),
    connectorId: z.string(),
    type: z.literal(VerificationType.Social),
    socialUserInfo: socialUserInfoGuard.optional(),
    encryptedTokenSet: encryptedTokenSetGuard.optional(),
    connectorSession: connectorSessionGuard.optional(),
});
export const sanitizedSocialVerificationRecordDataGuard = socialVerificationRecordDataGuard.omit({
    encryptedTokenSet: true,
    connectorSession: true,
});
